import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Form, Button, Card, Container } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { login } from "../actions/userActions";
import Messages from "./Messages";
import Loader from "./Loader";
import { useParams } from "react-router-dom";
import styled from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faKey, faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import { StyledInput, StyledLabel, ModernButton } from "../components/DefaultImports";
const StyledCard = styled.div`
  width: 100%;
  max-width: 500px;
  padding: 15px;
  margin: 0 auto;
  box-sizing: border-box;
`;
const PasswordContainer = styled.div`
  position: relative;
  margin-bottom: 1rem;
`;
const StyledPasswordInput = styled(StyledInput)`
  padding-right: 40px;
`;
const PasswordToggleIcon = styled.div`
  position: absolute;
  top: 40%;
  right: 12px;
  transform: translateY(-50%);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    font-size: 18px;
    color: #ee754c;
  }
`;
const CheckboxContainer = styled.label`
  display: grid;
  grid-template-columns: 1.15em auto;
  gap: 0.5em;
  font-family: system-ui, sans-serif;
  font-size: 1rem;
  font-weight: 500;
  align-items: center;
  cursor: pointer;
  margin: 1rem 0;
  user-select: none;
`;
const CustomCheckbox = styled.input.attrs({
  type: "checkbox"
})`
  appearance: none;
  width: 1.15em;
  height: 1.15em;
  border: 1px solid #999;
  border-radius: 4px;
  display: grid;
  place-content: center;
  margin: 0;
  cursor: pointer;
  background-color: #fff;
  transition: border-color 0.2s ease;

  &::before {
    content: "";
    width: 0.7em;
    height: 0.7em;
    transform: scale(0);
    transition: 120ms transform ease-in-out;
    box-shadow: inset 1em 1em #f59878;
    transform-origin: bottom left;
    clip-path: polygon(14% 44%, 0 65%, 50% 100%, 100% 16%, 80% 0%, 43% 62%);
  }

  &:checked::before {
    transform: scale(1);
  }

  &:focus {
    outline: none; /* <- Isso remove a borda azul */
  }
`;
const LinkStyleSpan = styled.span`
  color: #f59878;
  font-weight: 500;
  text-align: center;
  display: block;
  margin-top: 10px;
  cursor: pointer;
  text-decoration: underline;
  font-size: 14px;
`;
function FormContainer({
  history,
  onSwitchToRegister,
  onSwitchToRecovery
}) {
  const {
    t
  } = useTranslation();
  const params = useParams();
  const [email, setEmail] = useState(params.username !== "null" ? params.username : "");
  const [password, setPassword] = useState(params.password !== "null" ? params.password : "");
  const [showPasswords, setShowPasswords] = useState(true);
  const [rememberMe, setRememberMe] = useState(false);
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const redirect = location.search ? location.search.split("=")[1] : "/";
  const userLogin = useSelector(state => state.userLogin);
  const {
    userInfo,
    isLoading,
    error
  } = userLogin;
  const user_login_info = useSelector(state => state.userUpdate);
  const {
    login_info
  } = user_login_info;
  useEffect(() => {
    if (userInfo) {
      if (rememberMe) {
        localStorage.setItem("savedEmail", email);
      } else {
        localStorage.removeItem("savedEmail");
      }
      navigate(redirect);
    }
  }, [userInfo, rememberMe, email, navigate, redirect]);
  useEffect(() => {
    if (params.email !== "null" && params.password !== "null" && email !== "" && password !== "") {
      dispatch(login(email, password));
    }
  }, [email, password]);
  const submitHandler = e => {
    e.preventDefault();
    dispatch(login(email, password));
  };
  useEffect(() => {
    if (login_info && params.username !== "null") {
      dispatch(login(params.username, params.password));
    }
  }, [login_info, params]);
  useEffect(() => {
    const savedEmail = localStorage.getItem("savedEmail");
    if (savedEmail) {
      setEmail(savedEmail);
      setRememberMe(true);
    }
  }, []);
  const traduzirErro = mensagem => {
    const traducoes = {
      "No active account found with the given credentials": "Nenhuma conta com essas credenciais"
    };
    return traducoes[mensagem] || "Ocorreu um erro. Tente novamente.";
  };
  return <Container fluid style={{
    padding: 0,
    margin: 0,
    width: "120%",
    maxWidth: "120%"
  }}>
      <StyledCard>
        <Form onSubmit={submitHandler}>
          {error === "No active account found with the given credentials" && <Messages variant="danger">{traduzirErro(error)}</Messages>}
          {isLoading && <Loader />}
          <Form.Group controlId="formBasicEmail">
            <StyledInput type="email" placeholder={t("ui.components.formContainer.eMail")} value={email} onChange={e => setEmail(e.target.value)} style={{
            marginBottom: "10px"
          }} required />
          </Form.Group>
          <Form.Group controlId="formBasicPassword">
            <PasswordContainer>
              <StyledPasswordInput required type={showPasswords ? "password" : "text"} placeholder={t("ui.components.formContainer.palavraPasse")} value={password} onChange={e => setPassword(e.target.value)} />
              <PasswordToggleIcon onClick={() => setShowPasswords(!showPasswords)}>
                <FontAwesomeIcon icon={showPasswords ? faEyeSlash : faEye} />
              </PasswordToggleIcon>
            </PasswordContainer>
          </Form.Group>

          <CheckboxContainer>
            <CustomCheckbox checked={rememberMe} onChange={e => setRememberMe(e.target.checked)} />{t("ui.components.formContainer.lembrarEMail")}</CheckboxContainer>

          <ModernButton style={{
          width: "100%"
        }} color="#f59878" type="submit">{t("ui.components.formContainer.iniciarSessao")}</ModernButton>
          <Card.Text className="mt-3 text-center">{t("ui.components.formContainer.naoTemUmaConta")}<Button variant="link" style={{
            color: "#f59878",
            textDecoration: "none"
          }} onClick={onSwitchToRegister}>{t("ui.components.formContainer.criarConta")}</Button>
          </Card.Text>
          <LinkStyleSpan onClick={onSwitchToRecovery}>{t("ui.components.formContainer.esqueceuSeDaSuaPalavraPasse")}</LinkStyleSpan>
        </Form>
      </StyledCard>
    </Container>;
}
export default FormContainer;
